@if (fieldset.label ?? '' | translateInline; as label) {
  <h2 class="w-full form-fieldset__title">
    {{ label }}
  </h2>
}

<ng-content />
